/**
 * NativeWaves Content API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class ManagedStoresApi extends runtime.BaseAPI {
    /**
     * List access keys
     */
    async managedStoresClusterIdAccessKeysGetRaw(requestParameters, initOverrides) {
        if (requestParameters.clusterId === null ||
            requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling managedStoresClusterIdAccessKeysGet.');
        }
        const queryParameters = {};
        if (requestParameters.storeId !== undefined) {
            queryParameters['storeId'] = requestParameters.storeId;
        }
        if (requestParameters.keyId !== undefined) {
            queryParameters['keyId'] = requestParameters.keyId;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/managedStores/{clusterId}/accessKeys`.replace(`{${'clusterId'}}`, String(requestParameters.clusterId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List access keys
     */
    async managedStoresClusterIdAccessKeysGet(requestParameters, initOverrides) {
        const response = await this.managedStoresClusterIdAccessKeysGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of managed stores.
     */
    async managedStoresGetRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling managedStoresGet.');
        }
        const queryParameters = {};
        if (requestParameters.environmentId !== undefined) {
            queryParameters['environmentId'] = requestParameters.environmentId;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/managedStores`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of managed stores.
     */
    async managedStoresGet(requestParameters, initOverrides) {
        const response = await this.managedStoresGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a managed store.
     */
    async managedStoresPostRaw(requestParameters, initOverrides) {
        if (requestParameters.contentManagedStoreInsert === null ||
            requestParameters.contentManagedStoreInsert === undefined) {
            throw new runtime.RequiredError('contentManagedStoreInsert', 'Required parameter requestParameters.contentManagedStoreInsert was null or undefined when calling managedStoresPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/managedStores`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.contentManagedStoreInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a managed store.
     */
    async managedStoresPost(requestParameters, initOverrides) {
        const response = await this.managedStoresPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an access key
     */
    async managedStoresStoreIdAccessKeysKeyIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.storeId === null ||
            requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId', 'Required parameter requestParameters.storeId was null or undefined when calling managedStoresStoreIdAccessKeysKeyIdDelete.');
        }
        if (requestParameters.keyId === null ||
            requestParameters.keyId === undefined) {
            throw new runtime.RequiredError('keyId', 'Required parameter requestParameters.keyId was null or undefined when calling managedStoresStoreIdAccessKeysKeyIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/managedStores/{storeId}/accessKeys/{keyId}`
                .replace(`{${'storeId'}}`, String(requestParameters.storeId))
                .replace(`{${'keyId'}}`, String(requestParameters.keyId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an access key
     */
    async managedStoresStoreIdAccessKeysKeyIdDelete(requestParameters, initOverrides) {
        await this.managedStoresStoreIdAccessKeysKeyIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an access key
     */
    async managedStoresStoreIdAccessKeysKeyIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.storeId === null ||
            requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId', 'Required parameter requestParameters.storeId was null or undefined when calling managedStoresStoreIdAccessKeysKeyIdGet.');
        }
        if (requestParameters.keyId === null ||
            requestParameters.keyId === undefined) {
            throw new runtime.RequiredError('keyId', 'Required parameter requestParameters.keyId was null or undefined when calling managedStoresStoreIdAccessKeysKeyIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/managedStores/{storeId}/accessKeys/{keyId}`
                .replace(`{${'storeId'}}`, String(requestParameters.storeId))
                .replace(`{${'keyId'}}`, String(requestParameters.keyId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an access key
     */
    async managedStoresStoreIdAccessKeysKeyIdGet(requestParameters, initOverrides) {
        const response = await this.managedStoresStoreIdAccessKeysKeyIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an access key
     */
    async managedStoresStoreIdAccessKeysKeyIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.storeId === null ||
            requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId', 'Required parameter requestParameters.storeId was null or undefined when calling managedStoresStoreIdAccessKeysKeyIdPatch.');
        }
        if (requestParameters.keyId === null ||
            requestParameters.keyId === undefined) {
            throw new runtime.RequiredError('keyId', 'Required parameter requestParameters.keyId was null or undefined when calling managedStoresStoreIdAccessKeysKeyIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/managedStores/{storeId}/accessKeys/{keyId}`
                .replace(`{${'storeId'}}`, String(requestParameters.storeId))
                .replace(`{${'keyId'}}`, String(requestParameters.keyId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.basicIdentityPoolUserEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an access key
     */
    async managedStoresStoreIdAccessKeysKeyIdPatch(requestParameters, initOverrides) {
        const response = await this.managedStoresStoreIdAccessKeysKeyIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new access key
     */
    async managedStoresStoreIdAccessKeysPostRaw(requestParameters, initOverrides) {
        if (requestParameters.storeId === null ||
            requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId', 'Required parameter requestParameters.storeId was null or undefined when calling managedStoresStoreIdAccessKeysPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/managedStores/{storeId}/accessKeys`.replace(`{${'storeId'}}`, String(requestParameters.storeId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.basicIdentityPoolUserKeyInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new access key
     */
    async managedStoresStoreIdAccessKeysPost(requestParameters, initOverrides) {
        const response = await this.managedStoresStoreIdAccessKeysPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a managed store. This will not delete any content objects.
     */
    async managedStoresStoreIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.storeId === null ||
            requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId', 'Required parameter requestParameters.storeId was null or undefined when calling managedStoresStoreIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/managedStores/{storeId}`.replace(`{${'storeId'}}`, String(requestParameters.storeId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a managed store. This will not delete any content objects.
     */
    async managedStoresStoreIdDelete(requestParameters, initOverrides) {
        await this.managedStoresStoreIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a managed store.
     */
    async managedStoresStoreIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.storeId === null ||
            requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId', 'Required parameter requestParameters.storeId was null or undefined when calling managedStoresStoreIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/managedStores/{storeId}`.replace(`{${'storeId'}}`, String(requestParameters.storeId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a managed store.
     */
    async managedStoresStoreIdGet(requestParameters, initOverrides) {
        const response = await this.managedStoresStoreIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a managed store.
     */
    async managedStoresStoreIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.storeId === null ||
            requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId', 'Required parameter requestParameters.storeId was null or undefined when calling managedStoresStoreIdPatch.');
        }
        if (requestParameters.contentManagedStoreEdit === null ||
            requestParameters.contentManagedStoreEdit === undefined) {
            throw new runtime.RequiredError('contentManagedStoreEdit', 'Required parameter requestParameters.contentManagedStoreEdit was null or undefined when calling managedStoresStoreIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/managedStores/{storeId}`.replace(`{${'storeId'}}`, String(requestParameters.storeId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.contentManagedStoreEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a managed store.
     */
    async managedStoresStoreIdPatch(requestParameters, initOverrides) {
        const response = await this.managedStoresStoreIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const ManagedStoresGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
//# sourceMappingURL=ManagedStoresApi.js.map